import { ColorSwatchOption } from "../components/ColorSwatchSelector";

export const getLinearGradient = (option: ColorSwatchOption) =>
    `linear-gradient(to right, ${option?.swatch.map((color, index) => `${color.color} ${(index / option.swatch.length) * 100}%`).join(", ")})`;
